module.exports = __webpack_public_path__ + "b01f8013e23fcea95f601e2194a9d85e.svg";